import React from 'react'

const button = ({ handeClick ,btnColor, increment, children}) => {

    console.log(`Button ${children}`);

    return (
        <div>
            <button onClick={ () => handeClick(increment) }className={`btn btn-${btnColor} mt-3`}> + {increment} %</button>
        </div>
    )
}

export default React.memo(button)